<template>
  <div class="cmp-sidebar-layout-item">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export class SidebarLayoutItem extends Vue {}
export default SidebarLayoutItem;
</script>

<style lang="scss" scoped>
.cmp-sidebar-layout-item {
  background: $sidebar-layout-item-bg;
  box-shadow: $ws-box-shadow7;
  border: $ws-border-thick;
  border-radius: $ws-border-radius;
  position: relative;
  padding: map-get($space-4xl, y) map-get($space-5xl, x)
    map-get($space-4xl-b, y);

  &:first-of-type {
    margin-top: 0;
  }

  .theme--admin & {
    border: $ws-thin-line solid #D2D2D2;
    box-shadow: unset;
  }

  @media (max-width: $ws-breakpoint-tablet-max) {
    padding: map-get($space-lg, y) map-get($space-lg, x) map-get($space-xl, y);
  }

  @media (max-width: $ws-breakpoint-mobile-max) {
    padding: map-get($space-lg, y) map-get($space-md, x);
  }
}
</style>
